/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "/orders";

export const ORDERS_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Orders",
} as const;

export const ORDER_DETAIL_ROUTE = "/order/:orderId";
